import { DatePicker } from "antd";
import moment from "moment";
import { Button, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Filter } from "react-feather";
import Select from "react-select";


export const Search = ({ setSearchValue, searchValue, search }) => {
    return (
        <div className="mb-3 ">
            <Row className="g-2 align-items-center align-content-center ">
                <Col md={2}>
                    <Form.Control
                        type="text"
                        name="subject"
                        size="lg"
                        placeholder="Subject"
                        onChange={(event) => {
                            setSearchValue({
                                ...searchValue,
                                subject: event.target.value,
                            });
                        }}
                    />
                </Col>
                <Col md={2}>
                    <Form.Control
                        type="text"
                        name="module"
                        size="lg"
                        placeholder="Module Name"
                        onChange={(event) => {
                            setSearchValue({
                                ...searchValue,
                                module: event.target.value,
                            });
                        }}
                    />
                </Col>
                <Col md={2} >
                    <Select
                        className=" w-100"
                        classNamePrefix="react-select"
                        size="lg"
                        options={[
                            { value: "", label: "Select Status" },
                            { value: "1", label: "Success" },
                            { value: "0", label: "Failed" },
                        ]}
                        name="status"
                        placeholder="Status"
                        isClearable={true}
                        onChange={(event) => {
                            setSearchValue({
                                ...searchValue,
                                status: event?.value,
                            });
                        }}
                    />
                </Col>
                <Col md={2}>
                    <DatePicker
                        id="created-at-date-picker"
                        name="created_at"
                        className="form-control"
                        placeholder="Sent Date"
                        size="lg"
                        onChange={(e) =>
                            setSearchValue({
                                ...searchValue,
                                created_at: e
                                    ? moment(e).format("YYYY-MM-DD")
                                    : null,
                            })
                        }
                    />
                </Col>
                <Col md="auto">
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-search">Search filter</Tooltip>
                        }
                    >
                        <Button
                            variant="info"
                            onClick={(e) => {
                                e.preventDefault();
                                search();
                            }}
                            title="Search filter"
                            className="me-2"
                        >
                            <Filter size={15} />
                        </Button>
                    </OverlayTrigger>
                </Col>
            </Row>
        </div>
    );
};
